import React from 'react';
import { IconProps } from '@/models/IconProps';

const Minus: React.FC<IconProps> = ({ height = '24', width = '24', strokeColor = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H5Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default Minus;
